<header
  class="flex items-center justify-between px-6 h-16 border-b border-gray-200 bg-white"
>
  <!-- Título -->
  <div class="text-gray-700 font-semibold text-lg tracking-wide">
  </div>

  <!-- Acciones -->
  <div class="flex items-center gap-4">

    <!-- Usuario -->
    <div class="flex items-center gap-2">
      <div
        class="w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center cursor-pointer"
        (click)="goToProfile()"
      >
        {{ username()[0] }}
      </div>
      <span
        class="text-gray-700 font-medium hidden sm:inline cursor-pointer hover:underline"
        (click)="goToProfile()"
      >
        {{ username() }}
      </span>
    </div>

  </div>
</header>
